import React, { useContext, useEffect, useState } from "react";
import Navbar from "../Shared/Navbar/Navbar";
import medicen_default from "../../images/medicen_default.jpg";
import { AiFillStar, AiOutlineSearch } from "react-icons/ai";
import { GoPrimitiveDot } from "react-icons/go";
import { HiPlus } from "react-icons/hi";
import { HiOutlineX } from "react-icons/hi";
import Footer from "../Shared/Footer/Footer";
import { Link, useParams } from "react-router-dom";
import Cart from "../Cart/Cart";
import { context } from "../FrontPanel/FrontPanel";
import axios from "axios";
import Swal from "sweetalert2";

const MedicineList = () => {
  const params = useParams();
  const { pharmacyDataDetails, setPharmacyDataDetails } = useContext(context);

  const [medicenMasterData, setmedicenMasterData] = useState([]);
  const [medicineData, setmedicineData] = useState([]);
  const [medicenType, setmedicenType] = useState([]);
  const [activeClass, setactiveClass] = useState();

  useEffect(() => {
    const controller = new AbortController();

    if (Object.keys(pharmacyDataDetails).length === 0) {
      axios
        .get(`store-info/${params.id}`, {
          signal: controller.signal,
        })
        .then((res) => {
          setPharmacyDataDetails(res.data.data);
        });
    }

    axios
      .get(`products-by-seller/${params.id}`, {
        signal: controller.signal,
      })
      .then((res) => {
        setmedicineData(res.data.all);
        setmedicenMasterData(res.data.all);
      });
    axios
      .get(`drug-type`)
      .then((res) => {
        setmedicenType(res.data.all);
      })
      .catch((err) => {
        console.log(err);
      });



    return () => {
      controller.abort();
    };
  }, [params.id]);


  // Handle cart
  const { cart, setCart } = useContext(context);
  //add to cart

  const saveItemInCart = (item) => {
    if (Number(item.drug_restriction) === 1) {
      Swal.fire({
        title: "Upload your prescrption",
        input: "file",
        inputAttributes: {
          accept: "image/jpeg,image/png,application/pdf",
          required: "required",
        },
        showCancelButton: true,
        confirmButtonText: "Upload",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.isConfirmed) {
          const newCart = [...cart];
          newCart.push({ ...item, qty: 1, prescription: result.value });
          setCart(newCart);

          medicineData.map((pd) => {
            if (pd.id === item.id) {
              pd.drug_restriction = 0;
            }
          });

          Swal.fire({
            title: `Prescription add sucessfully`,
          });
        }
      });
    } else {
      const newCart = [...cart];
      let alreadyExist = false;
      cart.map((pd) => {
        if (pd.id === item.id) {
          pd.qty++;
          alreadyExist = true;
        }
      });
      if (!alreadyExist) {
        newCart.push({ ...item, qty: 1 });
      }
      setCart(newCart);
    }
  };

  const handleAddToCart = (item) => {
    const sessData = sessionStorage.getItem("se-as-i-as-d");
    if (sessData === null) {
      saveItemInCart(item);
      sessionStorage.setItem("se-as-i-as-d", item.seller_id);
    } else {
      if (Number(item.seller_id) === Number(sessData)) {
        saveItemInCart(item);
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: "Your selected item from diffrent seller, if you add item from this seller, your previous cart will be empty.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, add to cart!",
        }).then((result) => {
          if (result.isConfirmed) {
            setCart([{ ...item, qty: 1 }]);
            Swal.fire("Item added!", "Your item add sucessfully.", "success");
            sessionStorage.setItem("se-as-i-as-d", item.seller_id);
          }
        });
      }
    }
  };
  const addQty = (item) => {
    const newCart = [...cart];
    newCart.map((pd) => {
      if (pd.id === item.id) {
        pd.qty++;
      }
    });
    setCart(newCart);
  };
  //remove from cart
  const removeQty = (item) => {
    const newCart = [...cart];
    newCart.map((pd) => {
      if (pd.id === item.id && pd.qty > 1) {
        pd.qty--;
      }
    });
    setCart(newCart);
  };
  const removeProduct = (item) => {
    const existCart = [...cart];
    const newCart = existCart.filter((pd) => pd.id !== item.id);
    setCart(newCart);
  };
  // search
  const [filteredMedicine, setFilteredMedicine] = useState([]);
  const [searchWord, setSearchWord] = useState("");
  const [activeId, setActiveId] = useState(0);
  const [loading, setLoading] = useState(false);
  // Medicine add by onclick
  const medicineHandler = (item, i) => {
    let alreadyExist = false;
    const newCart = [...cart];
    newCart.map((pd) => {
      if (pd.id === item.id) {
        pd.qty++;
        alreadyExist = true;
      }
    });
    if (!alreadyExist) {
      newCart.push({
        ...item,
        qty: 1,
        boxType: "leaf",
        pktSize: 10,
        noOfBox: 1,
        pcs: 10,
        price: 20,
        disc: 10,
        totalPrice: 200,
        category: "Prescription",
      });
    }
    setCart(newCart);
    setActiveId(i);
  };
  // Navigate list from search result by down and up arrow
  const handleKeyPress = (e) => {
    if (e.code === "ArrowDown") {
      if (activeId < filteredMedicine.length - 1) {
        setActiveId((prev) => prev + 1);
      }
    } else if (e.code === "ArrowUp") {
      if (activeId !== 0) {
        setActiveId((prev) => prev - 1);
      }
    } else if (e.code === "Enter") {
      let alreadyExist = false;
      const newCart = [...cart];
      newCart.map((item) => {
        if (item.id === filteredMedicine[activeId].id) {
          item.qty++;
          alreadyExist = true;
        }
      });
      if (!alreadyExist && filteredMedicine.length > 0) {
        newCart.push({
          ...filteredMedicine[activeId],
          qty: 1,
          boxType: "leaf",
          pktSize: 10,
          noOfBox: 1,
          pcs: 10,
          price: 20,
          disc: 10,
          totalPrice: 200,
          category: "Prescription",
        });
      }

      setCart(newCart);
    }
  };
  // Search medicine from server
  // const handleSearch = (e) => {
  //   setSearchWord(e.target.value);
  //   if (e.target.value.length > 1) {
  //     setLoading(true);
  //     axios
  //       .get(
  //         `https://dev.macrohealthplus.org/mhp_server/public/api/search-drug/${e.target.value}`
  //       )
  //       .then((res) => {
  //         setFilteredMedicine(res.data);
  //         setLoading(false);
  //       });
  //     setActiveId(0);
  //   } else {
  //     setFilteredMedicine([]);
  //     setLoading(false);
  //     setActiveId(0);
  //   }
  // };
  const handleSearch = (e) => {
    const fil = medicineData.filter((item) =>
      item.name.toLowerCase().match(e.target.value.toLowerCase())
    );

    if (e.target.value.length > 0) {
      setmedicineData(fil);
    } else {
      axios.get(`products-by-seller/${params.id}`).then((res) => {
        setmedicineData(res.data.all);
      });
    }
  };
  const handlePresciptionMedicine = () => {
    const fil = medicineData.filter((item) =>
      Number(item.drug_restriction) === 1
    );
    setmedicineData(fil);
  }
  return (
    <div>
      <Navbar />
      <div className={`shop-bg-image `}>
        <img
          className="h-[180px] h-[180px] w-full"
          src={`${global.img_Url}/${pharmacyDataDetails.store_image}`}
          alt=""
        />
      </div>
      <div className="all-medicine-container">
        <div className="grid grid-cols-12">
          <div className="col-span-12 lg:col-span-9">
            <div className="ml-2 sm:ml-6 md:ml-12 lg:ml-20 xl-ml-28">
              <div className="pharmacy-detail py-4">
                <div className="flex justify-between">
                  <h2 className="text-[#134E47] font-bold lg:text-[18px]">
                    {pharmacyDataDetails?.store_name}
                  </h2>
                  <Link to={`/appointment/${pharmacyDataDetails?.id}`}>
                    <button className="py-1 bg-[#134E47] text-white font-medium rounded-lg px-2 mr-2">
                      Appointment
                    </button>
                  </Link>
                </div>
                <p className="text-[#134E47]">
                  <AiFillStar className="inline " />
                  <span className="text-[13px] font-semibold">4.5/5</span>
                  <span className="text-xs">(120)</span>
                </p>
                <ul className="text-[#134E47] list-disc">
                  <li className="inline-block text-xs">

                    <GoPrimitiveDot className="inline" /> Medicines
                  </li>
                  <li className="inline-block ml-2 text-xs">
                    <GoPrimitiveDot className="inline" /> Hospital Equipments
                  </li>
                  <li className="inline-block ml-2 text-xs">
                    <GoPrimitiveDot className="inline" /> Others
                  </li>
                </ul>
              </div>
            </div>
            <div className="custom-shadow lg:py-3 md:py-2 py-1">
              <div className="ml-2 sm:ml-6 md:ml-12 lg:ml-20 xl-ml-28">
                {medicenType.map((item, i) => (
                  <button
                    key={i}
                    onClick={() => {
                      setactiveClass(i);
                      const data = medicenMasterData.filter((value) =>
                        value.drug_type
                          .toLowerCase()
                          .match(item.name.toLowerCase())
                      );
                      setmedicineData(data);
                    }}
                    className={`${i === 0 ? "mr-3" : "mx-3"
                      } text-[12px] font-medium text-black ${i === activeClass && `drug_type_active`
                      }`}
                  >
                    {item.name}
                  </button>
                ))}
                <button
                  onClick={() => {
                    setmedicineData(medicenMasterData);
                    setactiveClass("active");
                  }}
                  className={`mx-3 text-[12px] font-medium text-black ${activeClass === "active" && `drug_type_active`
                    }`}
                >
                  All
                </button>
                <button onClick={handlePresciptionMedicine} className="text-[12px] font-bold border border-red-400 p-1 rounded">
                  Prescription Medicine
                </button>
              </div>
            </div>
            <div className="ml-2 sm:ml-6 md:ml-12 lg:ml-20 xl-ml-28">
              <div className="grid grid-cols-2 lg:py-3 md:py-2 py-1">
                <h2 className="text-[#134E47] font-bold lg:text-[16px]">
                  Popular Medicine
                </h2>
                <label className="relative block">
                  <span className="sr-only">Search</span>
                  <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                    <AiOutlineSearch />
                  </span>
                  {searchWord && (
                    <span className="absolute inset-y-0 right-0 flex items-center pr-2">
                      <HiOutlineX
                        onClick={() => {
                          setSearchWord("");
                          setFilteredMedicine([]);
                          setLoading(false);
                        }}
                        className="cursor-pointer"
                      />
                    </span>
                  )}
                  <input
                    // value={searchWord}
                    // onKeyDown={(e) => handleKeyPress(e)}
                    onChange={(e) => handleSearch(e)}
                    className="placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-none rounded-lg py-3 pl-9 pr-3 custom-shadow focus:outline-none focus:border-none focus:ring-none focus:ring-none text-sm"
                    placeholder="Search"
                    type="text"
                    name="search"
                  />
                </label>
              </div>
              {/* Filtered  medicine show  */}
              {filteredMedicine.length > 0 && !loading && (
                <div className="search-result-container g-doc-scroll pt-2 custom-card mb-2 p-2">
                  {filteredMedicine.map((item, i) => (
                    <div
                      key={i}
                      onClick={() => medicineHandler(item, i)}
                      className={`${activeId === i && "active-medicine"
                        } grid grid-cols-12 filtered-medicine mb-2 rounded`}
                    >
                      <div className="col-span-3">
                        <p>{item.macrohealth_sg}</p>
                      </div>
                      <div className="col-span-4">
                        <p>{item.drug_name}</p>
                      </div>
                      <div className="col-span-3">
                        <p>Exp.date: June, 2022</p>
                      </div>
                      <div className="col-span-2">
                        <p>
                          <span className="medicine-inStock">
                            In Stock
                            <i
                              style={{ fontSize: "7px" }}
                              className=" ms-2 fa-solid fa-circle"
                            ></i>
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {loading && (
                <i
                  style={{ fontSize: "20px", marginLeft: "50%" }}
                  className=" mt-2 fas fa-spinner fa-spin"
                ></i>
                // <FaSpinner/>
              )}
              {/* Filtered  medicine show  */}
              <div className="md:grid grid-cols-2 gap-3">
                {medicineData.map((item, i) => (
                  <div
                    key={i}
                    className="custom-shadow mb-2 sm:mb-0 rounded-lg p-4 grid grid-cols-12"
                    style={{ userSelect: "none" }}
                  >
                    <div className="col-span-9">
                      <h6 className="text-[#134E47] font-bold lg:text-[16px]">
                        {item.name}
                      </h6>
                      <p className="text-sm">{item.description}</p>
                      <p className="text-sm">{item.manufacturer}</p>
                    </div>
                    <div className="col-span-3">
                      <img
                        className="h-24 float-right"
                        src={`${item.image === ""
                          ? medicen_default
                          : `${global.img_Url}/${item.image}`
                          }`}
                        alt=""
                      />
                    </div>
                    <div className="flex justify-between col-span-12 mt-2">
                      <div>
                        <h6 className="text-[#134E47] font-bold lg:text-[16px] mt-1">
                          <span style={{ fontSize: "15px", fontWeight: 500 }}>

                            &#x9F3;
                          </span>
                          {item.price}
                        </h6>
                      </div>
                      <div>
                        {item.stock > 0 ? (
                          <HiPlus
                            onClick={() => handleAddToCart(item)}
                            className="cursor-pointer rounded mt-1 text-[20px] bg-[#134E47] text-white mr-1"
                          />
                        ) : (
                          <span className="text-red-600 font-bold">
                            Out of Stock
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {/* <div className="mt-5">
                <h2 className="text-[#134E47] font-bold lg:text-[16px] mb-3">
                  Popular Syrup
                </h2>
                <div className="md:grid grid-cols-2 gap-3">
                  {medicineData.map((item, i) => (
                    <div
                      key={i}
                      className="custom-shadow mb-2 sm:mb-0 rounded-lg p-4 grid grid-cols-12"
                    >
                      <div className="col-span-9">
                        <h6 className="text-[#134E47] font-bold lg:text-[16px]">
                          {item.name}
                        </h6>
                        <p className="text-sm">{item.details}</p>
                      </div>
                      <div className="col-span-3">
                        <img
                          className="h-24 float-right"
                          src={medicen_default}
                          alt=""
                        />
                      </div>
                      <div className="flex justify-between col-span-12 mt-2">
                        <div>
                          <h6 className="text-[#134E47] font-bold lg:text-[16px] mt-1">
                            <span style={{ fontSize: "15px", fontWeight: 500 }}>
                              
                              &#x9F3;
                            </span>
                            {item.price}
                          </h6>
                        </div>
                        <div>
                          <HiPlus
                            onClick={() => handleAddToCart(item)}
                            className="cursor-pointer rounded mt-1 text-[20px] bg-[#134E47] text-white mr-1"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-5">
                <h2 className="text-[#134E47] font-bold lg:text-[16px] mb-3">
                  Popular Lotion
                </h2>
                <div className="md:grid grid-cols-2 gap-3">
                  {medicineData.map((item, i) => (
                    <div
                      key={i}
                      className="custom-shadow mb-2 sm:mb-0 rounded-lg p-4 grid grid-cols-12"
                    >
                      <div className="col-span-9">
                        <h6 className="text-[#134E47] font-bold lg:text-[16px]">
                          {item.name}
                        </h6>
                        <p className="text-sm">{item.details}</p>
                      </div>
                      <div className="col-span-3">
                        <img
                          className="h-24 float-right"
                          src={medicen_default}
                          alt=""
                        />
                      </div>
                      <div className="flex justify-between col-span-12 mt-2">
                        <div>
                          <h6 className="text-[#134E47] font-bold lg:text-[16px] mt-1">
                            <span style={{ fontSize: "15px", fontWeight: 500 }}>
                              
                              &#x9F3;
                            </span>
                            {item.price}
                          </h6>
                        </div>
                        <div>
                          <HiPlus
                            onClick={() => handleAddToCart(item)}
                            className="cursor-pointer rounded mt-1 text-[20px] bg-[#134E47] text-white mr-1"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div> */}
            </div>
          </div>
          <div className="lg:col-span-3">
            <div className="sticky top-0">
              <Cart
                cart={cart}
                addQty={addQty}
                removeQty={removeQty}
                removeProduct={removeProduct}
                id={params.id}
              />
            </div>
          </div>
        </div>

        <div className="mx-2 sm:mx-6 md:mx-12 lg:mx-20 xl-mx-28">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default MedicineList;
